import CopyToClipboard from 'react-copy-to-clipboard';
import { Button } from '@mui/material';
import { Copy } from '@ankr.com/ui';
import { t } from '@ankr.com/common';

import { useCopyToClip } from 'uiKit/CopyToClipIcon/CopyToClipIconUtils';

import { useStyles } from './CopyCodeButtonStyles';

export interface CopyCodeButtonProps {
  className?: string;
  text?: string;
  code: string;
}

export const CopyCodeButton = ({
  className,
  code,
  text,
}: CopyCodeButtonProps) => {
  const [isCopied, setIsCopied] = useCopyToClip();

  const { classes } = useStyles();

  return (
    <CopyToClipboard
      // react-copy-to-clipboard forwards unknown props (className) to its
      // child at runtime, but its type definitions omit className.
      // @ts-expect-error upstream types don't model the prop passthrough
      className={className}
      text={code}
      onCopy={setIsCopied}
    >
      <Button
        className={classes.copyCodeButton}
        startIcon={<Copy />}
        variant="outlined"
        size="small"
      >
        {isCopied
          ? t(
              'chain-item.get-started.connection-snippet.copy-code-button.copy-message',
            )
          : text ||
            t(
              `chain-item.get-started.connection-snippet.copy-code-button.label`,
            )}
      </Button>
    </CopyToClipboard>
  );
};
